import { constantRoutes } from '@/router'
import Layout from '@/layout'// 【新加入】引入layout

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  // console.log(roles, route)
  if (route.meta && route.meta.roles) {
    // 遍历 roles 判断当前route中是否包换这个role,只要roles中有一个对象符合条件就返回true，全部对象都不符合条件才返回false
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    // 如果没有当前 route 没有meta或meta.roles 就默认显示这个路由
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

// 加载目录的地方
const actions = {
  generateRoutes({ commit }, data) {
    // console.log('generateRoutes', data)

    return new Promise(resolve => {
      const newRouteArr = []
      // data挨个遍历
      data.menuJson.forEach(item => {
        // path不为空的话，就新建一个对象，装数据
        if (item.path !== '') {
          // 这个就仿照目录的机构，搭建
          const menu = {
            path: item.path,
            component: Layout, // 这个不用写data里面的内容，引用就行了
            redirect: item.redirect,
            children: [],
            name: item.name,
            meta: item.meta,
            alwaysShow: true,
            hidden: item.hidden
          }
          if (item.children) {
            // 遍历子标签，并加入到主目录的children中去
            item.children.forEach(item => {
              const menu2 = {
                path: item.path,
                component: (resolve) => require([`@/views/${item.component}`], resolve),
                name: item.name,
                meta: item.meta,
                hidden: item.hidden
              }
              // 加入到主目录的children中去
              menu.children.push(menu2)
            })
          }
          newRouteArr.push(menu)
        }
      })
      // 把404加到最后，因为作者说  // 404 page must be placed at the end !!!
      const menu3 = {
        path: '*',
        redirect: '/404',
        hidden: true
      }
      // 追加
      newRouteArr.push(menu3)
      const roleArr = []
      data.roles.forEach(v => {
        roleArr.push(v.id)
      })
      const accessedRoutes = filterAsyncRoutes(newRouteArr, roleArr)
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

